
import { Component, OnInit, OnDestroy, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbService } from '@k12/navigation';
import { AdminUserType, ProviderData } from '@k12/models';
import {
  IUserRecordEmployeeService,
  IUserRecordProviderDetailsService
} from '@k12/tokens';
import { WORK_QUEUE_URL } from '@k12/admin-components';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-user-record-view-employee-detail',
  imports: [MatButtonModule, MatIconModule, MatProgressBarModule],
  templateUrl: './user-record-view-employee-detail.component.html'
})
export class UserRecordViewEmployeeDetailComponent implements OnInit, OnDestroy {
  // TODO: Refactor to inject services instead of using @Input once consuming application is refactored to use the new component structure with service injection
  @Input() employeeService!: IUserRecordEmployeeService;
  @Input() userRecordService!: IUserRecordProviderDetailsService;

  public employeeId: string | null = null;
  public employeeName: string | null = null;
  public personaId: number | null = null;
  public userId: string | null = null;
  public userData: ProviderData | null = null;

  private route = inject(ActivatedRoute);
  private breadcrumbService = inject(BreadcrumbService);

  public ngOnDestroy(): void {
    this.breadcrumbService.clearDynamicBreadcrumbs();
  }

  public ngOnInit(): void {
    const params = this.route.snapshot.paramMap;
    const state = history.state;
    this.personaId = Number(state?.['personaId']);

    // Prefer URL params — breadcrumb navigation does not restore `history.state`.
    this.userId = params.get('id') ?? state?.['providerId'];
    this.employeeId = params.get('employeeId') ?? state?.['employeeId'];
    this.employeeName = state?.['employeeName'];

    this.getUserDataForBreadcrumbs();
    document.documentElement.scrollTop = 0;
  }

  private getUserDataForBreadcrumbs(): void {
    const programPartnerId = this.userId;
    if (!programPartnerId || !this.userRecordService) {
      return;
    }

    this.userRecordService.getProviderDetails(programPartnerId, AdminUserType.Provider).subscribe((res: unknown) => {
      const data = res as ProviderData | null;
      this.userData = data;
      console.log('userData', this.userData);
      this.applyBreadcrumbLabels(data, programPartnerId);
    });
  }

  private applyBreadcrumbLabels(res: ProviderData | null | undefined, programPartnerId: string): void {
    let userName = 'User Record';
    if (res?.businessName?.trim()) {
      userName = res.businessName.trim();
    }
    this.breadcrumbService.setNestedDynamicBreadcrumbs(
      WORK_QUEUE_URL,
      programPartnerId,
      userName,
      undefined,
      'View Employees',
      this.employeeId ?? undefined,
      this.employeeName ?? undefined
    );
  }
}
